import { values } from 'lodash';
import { Column } from 'components/atoms/grid';
import { getEditor } from 'components/organisms/tasks/editors';
import { getRenderer } from 'components/organisms/tasks/renderers';
import { StatusField, TaskField } from 'stores/fields';
import { taskValueGetter } from './task-value-getter';

export const taskColumn = (fields: Record<number, TaskField>): Column => {
  const status_field = values(fields).find(
    (x) => x.fieldName === 'status',
  ) as StatusField | null;

  return {
    name: 'status',
    headerName: 'Task',
    renderer: 'agGroupCellRenderer',
    editable: true,
    rendererParams: {
      suppressCount: true,
      suppressDoubleClickExpand: true,
      fields,
      innerRenderer:
        status_field == null ? undefined : getRenderer(status_field),
    },
    editor: status_field == null ? undefined : getEditor(status_field),
    editorParams: {
      fields,
    },
    valueGetter: taskValueGetter,
    initialWidth: 400,
    comparator: (a, b, taskA, taskB) => {
      const a_status = (a?.status as number) ?? -1;
      const b_status = (b?.status as number) ?? -1;
      const a_name = (taskA?.taskName as string) ?? '';
      const b_name = (taskB?.taskName as string) ?? '';

      return a_status === b_status
        ? a_name === b_name
          ? 0
          : a_name < b_name
          ? -1
          : 1
        : a_status < b_status
        ? -1
        : 1;
    },
    lockPinned: true,
    lockPosition: true,
    pinned: true,
    group: true,
    cellStyle: {
      borderRight: '1px solid var(--table-border-color)',
    },
  };
};
